import { createAxiosApi } from "@/shared/axios/axios";

export type ChatWidgetReplyItem = {
    id: string;
    role: "agent";
    text: string;
    createdAt?: string;
};

export const chatWidgetRepliesApi = async (sessionId: string, since?: string) => {
    const params = new URLSearchParams({ sessionId });
    if (since) params.set("since", since);

    return createAxiosApi()<{ messages?: ChatWidgetReplyItem[]; nextCursor?: string }>({
        type: "get",
        url: `/chat-widget/replies?${params.toString()}`,
    }).then((res) => res.data);
};

